/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sales_CampaignsInputs */

const en_nav_sales_campaigns = /** @type {(inputs: Nav_Sales_CampaignsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales campaigns`)
};

/**
* | output |
* | --- |
* | "Sales campaigns" |
*
* @param {Nav_Sales_CampaignsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_sales_campaigns = /** @type {((inputs?: Nav_Sales_CampaignsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sales_CampaignsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_sales_campaigns(inputs)
});